<template>
  <a
      :href="href"
      class="text-uppercase text-center button-transparent text-secondary border border-secondary link-button"
      :class="class"
      v-if="hyperlink && text"
      :target="isExternalLink(href) ? '_blank' : null"
  >
    {{text}} <ArrowRightIcon class="ms-1" />
  </a>
  <button
      class="btn-nulled text-center button-transparent text-uppercase text-secondary border border-secondary button-base"
      :class="class"
      v-if="!hyperlink && text"
      @click="$emit('click', $event)"
  >
    {{ text }}
    <ArrowRightIcon class="ms-1"/>
  </button>
</template>

<script>
import ArrowRightIcon from "@/assets/icons/ArrowRightIcon";
import {isExternalLink} from "@/utils/utils";
export default {
  components: {ArrowRightIcon},
  props: {
    text: String,
    hyperlink: Boolean,
    href: String,
    class: String,
  },
  data(){
    return {
      isExternalLink
    }
  },
}
</script>
